import LawFirmSettings from './LawFirmSettings';

export default LawFirmSettings;
